export type UniverseProgram = {
  version: "0.1.0";
  name: "universe_program";
  instructions: [
    {
      name: "mintNft";
      accounts: [
        {
          name: "payerDmtrTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payerMintingInfo";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mintUniverseMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "config";
          isMut: false;
          isSigner: false;
        },
        {
          name: "candyMachine";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "wallet";
          isMut: true;
          isSigner: false;
        },
        {
          name: "metadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mintAuthority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "updateAuthority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "masterEdition";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenMetadataProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        },
        {
          name: "clock";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "universeMetadataBump";
          type: "u8";
        }
      ];
    },
    {
      name: "initializeConfig";
      accounts: [
        {
          name: "config";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "data";
          type: {
            defined: "ConfigData";
          };
        }
      ];
    },
    {
      name: "addConfigLines";
      accounts: [
        {
          name: "config";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "index";
          type: "u32";
        },
        {
          name: "configLines";
          type: {
            vec: {
              defined: "ConfigLine";
            };
          };
        }
      ];
    },
    {
      name: "initializeCandyMachine";
      accounts: [
        {
          name: "candyMachine";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wallet";
          isMut: false;
          isSigner: false;
        },
        {
          name: "config";
          isMut: false;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "bump";
          type: "u8";
        },
        {
          name: "data";
          type: {
            defined: "CandyMachineData";
          };
        }
      ];
    },
    {
      name: "updateAuthority";
      accounts: [
        {
          name: "candyMachine";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "newAuthority";
          type: {
            option: "publicKey";
          };
        }
      ];
    },
    {
      name: "withdrawFunds";
      accounts: [
        {
          name: "config";
          isMut: true;
          isSigner: false;
        },
        {
          name: "authority";
          isMut: false;
          isSigner: true;
        }
      ];
      args: [];
    },
    {
      name: "evolveUniverse";
      accounts: [
        {
          name: "mintUniverseMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "mint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "clock";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "updateUniverseMetadata";
      accounts: [
        {
          name: "mintUniverseMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "updateAuthority";
          isMut: true;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "status";
          type: "u8";
        },
        {
          name: "universeLevel";
          type: "u32";
        }
      ];
    },
    {
      name: "changeUniverseMetadataStatus";
      accounts: [
        {
          name: "mintUniverseMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "updateAuthority";
          isMut: true;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "status";
          type: "u8";
        }
      ];
    },
    {
      name: "addRarity";
      accounts: [
        {
          name: "mintUniverseMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "mint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "updateAuthority";
          isMut: true;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "rarity";
          type: "u8";
        }
      ];
    },
    {
      name: "mergeUniverses";
      accounts: [
        {
          name: "universeMetadataA";
          isMut: true;
          isSigner: false;
        },
        {
          name: "universeMetadataB";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftTokenA";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftTokenB";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftMintA";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftMintB";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "buyEvolutionPoints";
      accounts: [
        {
          name: "universeMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "nftTokenAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "nftMintAccount";
          isMut: false;
          isSigner: false;
        },
        {
          name: "evolutionToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "evolutionTokenHolding";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "amount";
          type: "u64";
        }
      ];
    },
    {
      name: "mintNftCollection";
      accounts: [
        {
          name: "universeMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "metaplexMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "editionPda";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "clock";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        },
        {
          name: "metadataProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "nftMint";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenReceiver";
          isMut: true;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "nftMetadataData";
          type: {
            defined: "MetadataDto";
          };
        }
      ];
    },
    {
      name: "initializeTokenReceivers";
      accounts: [
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "unqTokenHolding";
          isMut: true;
          isSigner: false;
        },
        {
          name: "unqTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "dmtrTokenHolding";
          isMut: true;
          isSigner: false;
        },
        {
          name: "dmtrTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "ntrnTokenHolding";
          isMut: true;
          isSigner: false;
        },
        {
          name: "ntrnTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "setMintingEpoch";
      accounts: [
        {
          name: "universeMetadata";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "mintingEpoch";
          type: "u64";
        }
      ];
    }
  ];
  accounts: [
    {
      name: "candyMachine";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "wallet";
            type: "publicKey";
          },
          {
            name: "tokenMint";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "config";
            type: "publicKey";
          },
          {
            name: "data";
            type: {
              defined: "CandyMachineData";
            };
          },
          {
            name: "itemsRedeemed";
            type: "u64";
          },
          {
            name: "bump";
            type: "u8";
          }
        ];
      };
    },
    {
      name: "config";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "data";
            type: {
              defined: "ConfigData";
            };
          }
        ];
      };
    },
    {
      name: "payerMintingInfo";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "totalMints";
            type: "u8";
          },
          {
            name: "bump";
            type: "u8";
          }
        ];
      };
    },
    {
      name: "universeMetadata";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "candyMachine";
            type: "publicKey";
          },
          {
            name: "mint";
            type: "publicKey";
          },
          {
            name: "mintingEpoch";
            type: "u64";
          },
          {
            name: "currentUniverseLevel";
            type: "u32";
          },
          {
            name: "status";
            type: "u8";
          },
          {
            name: "rarity";
            type: {
              defined: "Rarity";
            };
          },
          {
            name: "evolutionPoints";
            type: "u64";
          }
        ];
      };
    }
  ];
  types: [
    {
      name: "CandyMachineData";
      type: {
        kind: "struct";
        fields: [
          {
            name: "uuid";
            type: "string";
          },
          {
            name: "price";
            type: "u64";
          },
          {
            name: "itemsAvailable";
            type: "u64";
          },
          {
            name: "goLiveDate";
            type: {
              option: "i64";
            };
          }
        ];
      };
    },
    {
      name: "ConfigData";
      type: {
        kind: "struct";
        fields: [
          {
            name: "uuid";
            type: "string";
          },
          {
            name: "symbol";
            type: "string";
          },
          {
            name: "sellerFeeBasisPoints";
            type: "u16";
          },
          {
            name: "creators";
            type: {
              vec: {
                defined: "Creator";
              };
            };
          },
          {
            name: "maxSupply";
            type: "u64";
          },
          {
            name: "isMutable";
            type: "bool";
          },
          {
            name: "retainAuthority";
            type: "bool";
          },
          {
            name: "maxNumberOfLines";
            type: "u32";
          }
        ];
      };
    },
    {
      name: "ConfigLine";
      type: {
        kind: "struct";
        fields: [
          {
            name: "name";
            type: "string";
          },
          {
            name: "uri";
            type: "string";
          }
        ];
      };
    },
    {
      name: "Creator";
      type: {
        kind: "struct";
        fields: [
          {
            name: "address";
            type: "publicKey";
          },
          {
            name: "verified";
            type: "bool";
          },
          {
            name: "share";
            type: "u8";
          }
        ];
      };
    },
    {
      name: "MetadataDto";
      type: {
        kind: "struct";
        fields: [
          {
            name: "name";
            type: "string";
          },
          {
            name: "evolutionPoints";
            type: "u32";
          },
          {
            name: "rarity";
            type: "u8";
          },
          {
            name: "symbol";
            type: "string";
          },
          {
            name: "uri";
            type: "string";
          },
          {
            name: "mintingEpoch";
            type: "u64";
          }
        ];
      };
    },
    {
      name: "Rarity";
      type: {
        kind: "enum";
        variants: [
          {
            name: "Common";
          },
          {
            name: "Rare";
          },
          {
            name: "Epic";
          },
          {
            name: "Legendary";
          }
        ];
      };
    },
    {
      name: "LowerNFT";
      type: {
        kind: "enum";
        variants: [
          {
            name: "A";
          },
          {
            name: "B";
          }
        ];
      };
    }
  ];
  errors: [
    {
      code: 6000;
      name: "IncorrectOwner";
      msg: "Account does not have correct owner!";
    },
    {
      code: 6001;
      name: "Uninitialized";
      msg: "Account is not initialized!";
    },
    {
      code: 6002;
      name: "MintMismatch";
      msg: "Mint Mismatch!";
    },
    {
      code: 6003;
      name: "IndexGreaterThanLength";
      msg: "Index greater than length!";
    },
    {
      code: 6004;
      name: "ConfigMustHaveAtleastOneEntry";
      msg: "Config must have atleast one entry!";
    },
    {
      code: 6005;
      name: "NumericalOverflowError";
      msg: "Numerical overflow error!";
    },
    {
      code: 6006;
      name: "TooManyCreators";
      msg: "Can only provide up to 4 creators to candy machine (because candy machine is one)!";
    },
    {
      code: 6007;
      name: "UuidMustBeExactly6Length";
      msg: "Uuid must be exactly of 6 length";
    },
    {
      code: 6008;
      name: "NotEnoughTokens";
      msg: "Not enough tokens to pay for this minting";
    },
    {
      code: 6009;
      name: "NotEnoughSOL";
      msg: "Not enough SOL to pay for this minting";
    },
    {
      code: 6010;
      name: "TokenTransferFailed";
      msg: "Token transfer failed";
    },
    {
      code: 6011;
      name: "CandyMachineEmpty";
      msg: "Candy machine is empty!";
    },
    {
      code: 6012;
      name: "CandyMachineNotLiveYet";
      msg: "Candy machine is not live yet!";
    },
    {
      code: 6013;
      name: "ConfigLineMismatch";
      msg: "Number of config lines must be at least number of items available";
    },
    {
      code: 6014;
      name: "NoDMTR";
      msg: "You need DMTR token to mint";
    },
    {
      code: 6015;
      name: "UniverseAlreadyEvolving";
      msg: "This Universe is currently evolving!";
    },
    {
      code: 6016;
      name: "NoEvolutionPoints";
      msg: "This Universe doesn't have evolution points!";
    },
    {
      code: 6017;
      name: "WrongEvolutionCurrency";
      msg: "Wrong currency: Must be UNQ, NTRN or DMTR";
    },
    {
      code: 6018;
      name: "WrongEvolutionAmountOfTokens";
      msg: "Wrong Amount of tokens for evolution";
    },
    {
      code: 6019;
      name: "WrongTokenHoldingAddress";
      msg: "Wrong token holding address";
    }
  ];
};

export const IDL: UniverseProgram = {
  version: "0.1.0",
  name: "universe_program",
  instructions: [
    {
      name: "mintNft",
      accounts: [
        {
          name: "payerDmtrTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payerMintingInfo",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mintUniverseMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "config",
          isMut: false,
          isSigner: false,
        },
        {
          name: "candyMachine",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "wallet",
          isMut: true,
          isSigner: false,
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenMetadataProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
        {
          name: "clock",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "universeMetadataBump",
          type: "u8",
        },
      ],
    },
    {
      name: "initializeConfig",
      accounts: [
        {
          name: "config",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "data",
          type: {
            defined: "ConfigData",
          },
        },
      ],
    },
    {
      name: "addConfigLines",
      accounts: [
        {
          name: "config",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "index",
          type: "u32",
        },
        {
          name: "configLines",
          type: {
            vec: {
              defined: "ConfigLine",
            },
          },
        },
      ],
    },
    {
      name: "initializeCandyMachine",
      accounts: [
        {
          name: "candyMachine",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wallet",
          isMut: false,
          isSigner: false,
        },
        {
          name: "config",
          isMut: false,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "bump",
          type: "u8",
        },
        {
          name: "data",
          type: {
            defined: "CandyMachineData",
          },
        },
      ],
    },
    {
      name: "updateAuthority",
      accounts: [
        {
          name: "candyMachine",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "newAuthority",
          type: {
            option: "publicKey",
          },
        },
      ],
    },
    {
      name: "withdrawFunds",
      accounts: [
        {
          name: "config",
          isMut: true,
          isSigner: false,
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
        },
      ],
      args: [],
    },
    {
      name: "evolveUniverse",
      accounts: [
        {
          name: "mintUniverseMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "clock",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "updateUniverseMetadata",
      accounts: [
        {
          name: "mintUniverseMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "status",
          type: "u8",
        },
        {
          name: "universeLevel",
          type: "u32",
        },
      ],
    },
    {
      name: "changeUniverseMetadataStatus",
      accounts: [
        {
          name: "mintUniverseMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "status",
          type: "u8",
        },
      ],
    },
    {
      name: "addRarity",
      accounts: [
        {
          name: "mintUniverseMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "rarity",
          type: "u8",
        },
      ],
    },
    {
      name: "mergeUniverses",
      accounts: [
        {
          name: "universeMetadataA",
          isMut: true,
          isSigner: false,
        },
        {
          name: "universeMetadataB",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftTokenA",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftTokenB",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftMintA",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftMintB",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "buyEvolutionPoints",
      accounts: [
        {
          name: "universeMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "nftTokenAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "nftMintAccount",
          isMut: false,
          isSigner: false,
        },
        {
          name: "evolutionToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "evolutionTokenHolding",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "amount",
          type: "u64",
        },
      ],
    },
    {
      name: "mintNftCollection",
      accounts: [
        {
          name: "universeMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "metaplexMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "editionPda",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "clock",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
        {
          name: "metadataProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "nftMint",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenReceiver",
          isMut: true,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "nftMetadataData",
          type: {
            defined: "MetadataDto",
          },
        },
      ],
    },
    {
      name: "initializeTokenReceivers",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "unqTokenHolding",
          isMut: true,
          isSigner: false,
        },
        {
          name: "unqTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "dmtrTokenHolding",
          isMut: true,
          isSigner: false,
        },
        {
          name: "dmtrTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "ntrnTokenHolding",
          isMut: true,
          isSigner: false,
        },
        {
          name: "ntrnTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "setMintingEpoch",
      accounts: [
        {
          name: "universeMetadata",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "mintingEpoch",
          type: "u64",
        },
      ],
    },
  ],
  accounts: [
    {
      name: "candyMachine",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "wallet",
            type: "publicKey",
          },
          {
            name: "tokenMint",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "config",
            type: "publicKey",
          },
          {
            name: "data",
            type: {
              defined: "CandyMachineData",
            },
          },
          {
            name: "itemsRedeemed",
            type: "u64",
          },
          {
            name: "bump",
            type: "u8",
          },
        ],
      },
    },
    {
      name: "config",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "data",
            type: {
              defined: "ConfigData",
            },
          },
        ],
      },
    },
    {
      name: "payerMintingInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "totalMints",
            type: "u8",
          },
          {
            name: "bump",
            type: "u8",
          },
        ],
      },
    },
    {
      name: "universeMetadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "candyMachine",
            type: "publicKey",
          },
          {
            name: "mint",
            type: "publicKey",
          },
          {
            name: "mintingEpoch",
            type: "u64",
          },
          {
            name: "currentUniverseLevel",
            type: "u32",
          },
          {
            name: "status",
            type: "u8",
          },
          {
            name: "rarity",
            type: {
              defined: "Rarity",
            },
          },
          {
            name: "evolutionPoints",
            type: "u64",
          },
        ],
      },
    },
  ],
  types: [
    {
      name: "CandyMachineData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "uuid",
            type: "string",
          },
          {
            name: "price",
            type: "u64",
          },
          {
            name: "itemsAvailable",
            type: "u64",
          },
          {
            name: "goLiveDate",
            type: {
              option: "i64",
            },
          },
        ],
      },
    },
    {
      name: "ConfigData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "uuid",
            type: "string",
          },
          {
            name: "symbol",
            type: "string",
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16",
          },
          {
            name: "creators",
            type: {
              vec: {
                defined: "Creator",
              },
            },
          },
          {
            name: "maxSupply",
            type: "u64",
          },
          {
            name: "isMutable",
            type: "bool",
          },
          {
            name: "retainAuthority",
            type: "bool",
          },
          {
            name: "maxNumberOfLines",
            type: "u32",
          },
        ],
      },
    },
    {
      name: "ConfigLine",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string",
          },
          {
            name: "uri",
            type: "string",
          },
        ],
      },
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey",
          },
          {
            name: "verified",
            type: "bool",
          },
          {
            name: "share",
            type: "u8",
          },
        ],
      },
    },
    {
      name: "MetadataDto",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string",
          },
          {
            name: "evolutionPoints",
            type: "u32",
          },
          {
            name: "rarity",
            type: "u8",
          },
          {
            name: "symbol",
            type: "string",
          },
          {
            name: "uri",
            type: "string",
          },
          {
            name: "mintingEpoch",
            type: "u64",
          },
        ],
      },
    },
    {
      name: "Rarity",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Common",
          },
          {
            name: "Rare",
          },
          {
            name: "Epic",
          },
          {
            name: "Legendary",
          },
        ],
      },
    },
    {
      name: "LowerNFT",
      type: {
        kind: "enum",
        variants: [
          {
            name: "A",
          },
          {
            name: "B",
          },
        ],
      },
    },
  ],
  errors: [
    {
      code: 6000,
      name: "IncorrectOwner",
      msg: "Account does not have correct owner!",
    },
    {
      code: 6001,
      name: "Uninitialized",
      msg: "Account is not initialized!",
    },
    {
      code: 6002,
      name: "MintMismatch",
      msg: "Mint Mismatch!",
    },
    {
      code: 6003,
      name: "IndexGreaterThanLength",
      msg: "Index greater than length!",
    },
    {
      code: 6004,
      name: "ConfigMustHaveAtleastOneEntry",
      msg: "Config must have atleast one entry!",
    },
    {
      code: 6005,
      name: "NumericalOverflowError",
      msg: "Numerical overflow error!",
    },
    {
      code: 6006,
      name: "TooManyCreators",
      msg: "Can only provide up to 4 creators to candy machine (because candy machine is one)!",
    },
    {
      code: 6007,
      name: "UuidMustBeExactly6Length",
      msg: "Uuid must be exactly of 6 length",
    },
    {
      code: 6008,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to pay for this minting",
    },
    {
      code: 6009,
      name: "NotEnoughSOL",
      msg: "Not enough SOL to pay for this minting",
    },
    {
      code: 6010,
      name: "TokenTransferFailed",
      msg: "Token transfer failed",
    },
    {
      code: 6011,
      name: "CandyMachineEmpty",
      msg: "Candy machine is empty!",
    },
    {
      code: 6012,
      name: "CandyMachineNotLiveYet",
      msg: "Candy machine is not live yet!",
    },
    {
      code: 6013,
      name: "ConfigLineMismatch",
      msg: "Number of config lines must be at least number of items available",
    },
    {
      code: 6014,
      name: "NoDMTR",
      msg: "You need DMTR token to mint",
    },
    {
      code: 6015,
      name: "UniverseAlreadyEvolving",
      msg: "This Universe is currently evolving!",
    },
    {
      code: 6016,
      name: "NoEvolutionPoints",
      msg: "This Universe doesn't have evolution points!",
    },
    {
      code: 6017,
      name: "WrongEvolutionCurrency",
      msg: "Wrong currency: Must be UNQ, NTRN or DMTR",
    },
    {
      code: 6018,
      name: "WrongEvolutionAmountOfTokens",
      msg: "Wrong Amount of tokens for evolution",
    },
    {
      code: 6019,
      name: "WrongTokenHoldingAddress",
      msg: "Wrong token holding address",
    },
  ],
};
